import { Link } from "react-router-dom";
import Logo from "../Logo";

export default function Footer({ contact }) {
  return (
    <footer className="border-t border-white/10 bg-jauja-bg py-12" data-testid="landing-footer">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div>
          <Logo height={32} />
          <p className="mt-2 text-sm text-white/40">Experiencias memorables · Cultura & Comunicación</p>
        </div>
        <div className="text-sm text-white/50 space-y-1">
          {contact?.email && <div>{contact.email}</div>}
          {contact?.phone && <div>{contact.phone}</div>}
          {contact?.address && <div>{contact.address}</div>}
        </div>
        <div className="text-sm">
          <Link to="/admin" className="text-white/40 hover:text-jauja-lime transition-colors" data-testid="footer-admin-link">
            Administración
          </Link>
        </div>
      </div>
      <div className="mx-auto max-w-7xl px-5 sm:px-8 mt-8 pt-6 border-t border-white/5 text-xs text-white/30">
        © {new Date().getFullYear()} Jauja Consultores. Todos los derechos reservados.
      </div>
    </footer>
  );
}
